import type { FC, SVGProps } from 'react';

const FewCloudsIcon: FC<SVGProps<SVGSVGElement>> = ({ ...props }) => {
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3346 0.5C15.0961 0.5 17.3346 2.73857 17.3346 5.5C17.3346 6.80117 16.8376 7.98633 16.0231 8.87583C16.3291 9.49033 16.5013 10.1833 16.5013 10.9167C16.5013 13.3863 14.5482 15.3996 12.1023 15.4964L11.918 15.5H4.41797C2.3469 15.5 0.667969 13.8211 0.667969 11.75C0.667969 10.1153 1.71339 8.72567 3.17239 8.212C3.16945 8.14167 3.16797 8.071 3.16797 8C3.16797 5.29412 5.31739 3.09027 8.00197 3.00271C8.86614 1.50671 10.4828 0.5 12.3346 0.5ZM8.16797 4.66667C6.32702 4.66667 4.83464 6.15905 4.83464 8C4.83464 8.15472 4.84512 8.30659 4.86534 8.45504L4.90287 8.67508C5.00341 9.1645 4.65989 9.6245 4.17503 9.68058C3.13927 9.80033 2.33464 10.6818 2.33464 11.75C2.33464 12.8546 3.19425 13.7584 4.28099 13.8289L4.41797 13.8333H11.918C13.5288 13.8333 14.8346 12.5275 14.8346 10.9167C14.8346 9.39608 13.6705 8.1465 12.1854 8.012C11.8152 7.9785 11.5096 7.70575 11.4361 7.33942C11.13 5.81482 9.78214 4.66667 8.16797 4.66667ZM12.3346 2.16667C11.343 2.16667 10.4525 2.59971 9.84189 3.28701C11.2957 3.80335 12.4395 4.97337 12.9207 6.4435C13.7054 6.61867 14.4141 6.99492 14.99 7.51525C15.4155 6.95558 15.668 6.25727 15.668 5.5C15.668 3.65905 14.1756 2.16667 12.3346 2.16667Z"
        fill="#413B56"
      />
    </svg>
  );
};

export default FewCloudsIcon;
